import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';

import { GameLogic } from '../../Logic/GameLogic';
import { AnimationContents } from '../../../AnimationContents';
import { EnvironmentModel, EnvironmentTypeEnum } from '../../Models/EnvironmentModel';

export class EnvironmentController extends AnimationBaseController {
    $model: EnvironmentModel;

    public constructor(
        @Inject private _options,
        @Inject private _gameLogic: GameLogic,
    ) {
        super('EnvironmentController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.GAME_SCREEN_JSON,
            libraryName: 'environments_container',
            childControllers: {},
            modelWatch: {
                pos: (pos: [number, number]) => {
                    this.x = pos[0];
                    this.y = pos[1];
                },
                type: (type: EnvironmentTypeEnum) => {
                    this.setType(this.$model.type);
                },
                visible: (value: boolean) => {
                    this.setType(this.$model.type);
                },
            },
        };
    }

    protected onInitialize(): void {
        this.x = this.$model.pos[0];
        this.y = this.$model.pos[1];

        this.setType(this.$model.type);
    }

    private setType(type: EnvironmentTypeEnum): void {
        if (this.$model.visible && type !== EnvironmentTypeEnum.none) {
            this.gotoAndStopByQuery('environments', type);
            this.getCurrentPointsPaths((x, y, paths, shapeContainer, shape) => {
                shapeContainer.visible = false;
            }, 'environments');

        } else {
            this.gotoAndStopByQuery('environments',  EnvironmentTypeEnum.none);
        }
    }
}
